import { ProviderItemInputs } from './provider-item-inputs';
import { ProviderDetails } from 'src/app/models/provider-details';

export class CheckProviderData {
    public providerDetails: ProviderDetails;
    public providerItemInputs: ProviderItemInputs[];
    constructor(providerDetails: ProviderDetails, providerItemInputs: ProviderItemInputs[]) {
        this.providerDetails = providerDetails;
        this.providerItemInputs = providerItemInputs;
    }
}